
import Vue from "vue";
import HeaderDropDownFilter, {
  OptionItem
} from "@/components/BaseHeaderDropDownFilter.vue";

export type FilterCondition = {
  status?: string;
};

export type DataType = {
  filterCondition: FilterCondition;
  statusOptions: Array<OptionItem>;
};

export default Vue.extend({
  name: "GatewayListHeader",

  components: {
    HeaderDropDownFilter
  },

  computed: {
    isAdmin(): boolean {
      return this.$auth.role === "admin";
    }
  },

  data(): DataType {
    return {
      filterCondition: {
        status: undefined
      },
      statusOptions: [
        {
          label: "稼動",
          value: "running"
        },
        {
          label: "停止",
          value: "stopped",
          classes: ["red"]
        }
      ]
    };
  },

  methods: {
    updateFilterConditionAndSearch(): void {
      this.$emit("update-filter-condition", this.filterCondition);
      this.$emit("search");
    }
  }
});
